module.exports = __webpack_public_path__ + "fonts/Inter-ExtraBoldItalic.0e4b21e.woff";